import type { FollowCursorTooltipProps } from './index.types';
import { useTooltipFollowCursor } from 'Hooks/followCursor';
import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Domain-agnostic tooltip that follows the cursor.
 *
 * Render-prop wrapper around {@link useTooltipFollowCursor}: it provides the
 * `onMouseEnter`/`onMouseLeave` handlers to attach to the trigger element and
 * renders the tooltip (via portal) next to the cursor when `tooltipInfo.show`
 * is `true`.
 */
export const FollowCursorTooltip = ({
  children,
  tooltipInfo,
  delay = 400,
}: FollowCursorTooltipProps) => {
  const { tooltipRef, currentMousePosition, handlers } = useTooltipFollowCursor(
    tooltipInfo,
    { delay }
  );

  return (
    <>
      {children(handlers)}

      {tooltipInfo?.show &&
        tooltipInfo.message &&
        typeof window !== 'undefined' &&
        createPortal(
          <div
            ref={tooltipRef}
            style={{
              position: 'fixed',
              left: `${currentMousePosition.x + 12}px`,
              top: `${currentMousePosition.y - 12}px`,
              transform: 'translate(0, -100%)',
              zIndex: 9999,
              pointerEvents: 'none',
              display: 'none',
            }}
            className="z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 pointer-events-none"
          >
            {tooltipInfo.message}
          </div>,
          document.body
        )}
    </>
  );
};
